import { B100, B200, B400, B50, DN600, N0, N200, N30, N40, N500, N600, N700, N800, N900 } from '@atlaskit/theme/colors';
const textColor = {
  light: `var(--ds-text, ${N900})`,
  dark: `var(--ds-text, ${DN600})`
};
const textColorMedium = `var(--ds-text-subtle, ${N600})`;
const todayColor = {
  light: `var(--ds-text-selected, ${B400})`,
  dark: `var(--ds-text-selected, ${B100})`
};
const hoverBackground = {
  light: `var(--ds-background-neutral-subtle-hovered, ${N30})`,
  dark: `var(--ds-background-neutral-subtle-hovered, ${N800})`
};
const textSelected = {
  light: `var(--ds-text-selected, ${N0})`,
  dark: `var(--ds-text-selected, ${N700})`
};
const selectedBackground = {
  light: `var(--ds-background-selected, ${N500})`,
  dark: `var(--ds-background-selected, ${N0})`
};
const borderColorFocused = {
  light: `var(--ds-border-focused, ${B200})`,
  dark: `var(--ds-border-focused, ${B100})`
};
export const dateCellStyles = (mode = 'light') => ({
  all: 'unset',
  display: 'block',
  padding: `${"var(--ds-space-050, 4px)"} 9px`,
  position: 'relative',
  backgroundColor: 'transparent',
  border: '2px solid transparent',
  borderRadius: 3,
  color: textColor[mode],
  cursor: 'pointer',
  flexGrow: 1,
  fontSize: "var(--ds-font-size-100, 14px)",
  textAlign: 'center',
  '&[data-sibling]': {
    color: `var(--ds-text-subtlest, ${N200})`
  },
  '&[data-today]': {
    color: todayColor[mode],
    fontWeight: "var(--ds-font-weight-bold, bold)",
    '&::after': {
      display: 'block',
      height: 2,
      position: 'absolute',
      right: "var(--ds-space-025, 2px)",
      bottom: "var(--ds-space-025, 2px)",
      left: "var(--ds-space-025, 2px)",
      backgroundColor: 'currentColor',
      content: '""'
    }
  },
  '&[data-prev-selected]': {
    backgroundColor: `var(--ds-background-selected, ${B50})`,
    color: `var(--ds-text-subtle, ${N600})`
  },
  '&[data-selected]': {
    backgroundColor: selectedBackground[mode],
    color: textSelected[mode]
  },
  '&[data-disabled]': {
    color: `var(--ds-text-disabled, ${N40})`,
    cursor: 'not-allowed'
  },
  '&:focus-visible': {
    border: `2px solid ${borderColorFocused[mode]}`
  },
  '&:hover': {
    backgroundColor: hoverBackground[mode],
    color: textColor[mode]
  },
  '&:active': {
    backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${B50})`,
    color: textColor[mode]
  },
  '&[data-selected]:hover': {
    backgroundColor: `var(--ds-background-selected-hovered, ${B50})`,
    color: `var(--ds-text-selected, ${N600})`
  },
  '&[data-prev-selected]:hover': {
    color: textColorMedium
  },
  '&[data-sibling]:hover': {
    color: `var(--ds-text-subtlest, ${N200})`
  },
  '&[data-disabled]:hover': {
    backgroundColor: 'transparent',
    color: `var(--ds-text-disabled, ${N40})`
  }
});